// HOOKS
import useScreenSize from "../../../../hooks/useScreenSize";

// REDUX
import { useDispatch } from "react-redux";
import { updateCryptoStep } from "../../../../store/slices/cryptoSlice";
import { useAppSelector } from "../../../../store/hooks";

// COMPONENTS
import { ModalBody, ModalHeader } from "@nextui-org/react";
import { ButtonsFooter } from "../ButtonsFooter/ButtonsFooter";

// CONSTANTS
import { MOBILE_OPERATE_WIDTH } from "../../../OperateMEP/constants";

// STYLES
import styles from "./StatusModal.module.scss";

// STYLES
import SuccessIcon from "../../../../assets/images/icons/ui/states/success-dark-filled-icon.svg?react";
import ErrorIcon from "../../../../assets/images/icons/ui/states/error-filled-icon.svg?react";
import SuccessMobileIcon from "../../../../assets/images/icons/ui/states/success-filled-icon.svg?react";
import ErrorMobileIcon from "../../../../assets/icons/error-light-icon.svg?react";

interface Props {
  onClose: () => void;
  companyName: string;
}
const StatusModal = ({ companyName, onClose }: Props) => {
  const {
    header,
    flexContainer,
    successColor,
    description,
    statusImage,
  } = styles;
  const { isMobile } = useScreenSize(MOBILE_OPERATE_WIDTH);
  const dispatch = useDispatch();
  const { status } = useAppSelector((state) => state.crypto);
  const isSuccess = status === "SUCCESS";

  return (
    <>
      <ModalHeader
        className={`${statusImage} ${isMobile && !isSuccess ? "pt-[35vh]" : isMobile && isSuccess ? "pt-[30vh]" : ""} gap-[1.5rem]`}
      >
        {!isMobile ? (
          isSuccess ? (
            <SuccessIcon />
          ) : (
            <ErrorIcon />
          )
        ) : isSuccess ? (
          <SuccessMobileIcon />
        ) : (
          <ErrorMobileIcon />
        )}
        <span
          className={`${header} ${isSuccess && !isMobile ? successColor : ""}`}
        >
          {!isMobile
            ? isSuccess
              ? "Cuenta creada correctamente."
              : "Falló la creación de cuenta."
            : isSuccess
              ? `¡Creaste tu cuenta en ${companyName}!`
              : "Algo salió mal"}
        </span>
      </ModalHeader>
      <ModalBody
        className={`${flexContainer} ${isMobile && "pt-[0rem] gap-[0.62rem]"}`}
      >
        <span className={description}>
          {!isMobile
            ? isSuccess
              ? "Ya podés operar con landtoken y otras criptomonedas."
              : "Volvé a intentar nuevamente."
            : isSuccess
              ? `Vamos a redirigirte a ${companyName} para que puedas empezar a operar ¿estás seguro que querés salir?`
              : "Por favor, intentá nuevamente."}
        </span>
      </ModalBody>
      <ButtonsFooter
        isMobile={isMobile}
        primaryButton={{
          text: isSuccess ? `Ir a ${companyName}` : "Volver a intentar",
          handleClick: isSuccess
            ? () => dispatch(updateCryptoStep("REDIRECT"))
            : () => dispatch(updateCryptoStep("CONFIRM")),
          isDisabled: false,
        }}
        secondaryButton={{
          text: isSuccess ? "Volver" : "Cerrar",
          handleClick: isSuccess
            ? () => dispatch(updateCryptoStep("CONFIRM"))
            : onClose,
          isDisabled: false,
        }}
      />
    </>
  );
};

export default StatusModal;
